import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable} from "rxjs";
import {MatDrawer} from "@angular/material/sidenav";
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import {Router} from "@angular/router";
import {SavedReportPageStore} from "../../shared/store/savedReportsPage/savedReportPage.store";
import {SavedReportComponentObject, SavedReportComponentObjects} from '../../shared/classes/saved-report-component-object';
import {FolderComponentObject, FolderComponentObjects} from '../../shared/classes/folder-component-object';
import {SearchBarComponent} from './search-bar/search-bar.component';

@Component({
  selector: 'app-saved-reports',
  templateUrl: './saved-reports.component.html',
  styleUrls: ['./saved-reports.component.scss'],
  providers: [SavedReportPageStore]
})
export class SavedReportsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('reportSideNav') private readonly drawer: MatDrawer;

  public navReport: SavedReportComponentObject;

  public readonly loading$: Observable<boolean> = this._savedReportPageStore.loading$;
  public readonly savedReportsInitialized$: Observable<boolean> = this._savedReportPageStore.savedReportsInitialized$;

  public readonly initialized$: Observable<boolean> = this._savedReportPageStore.initialized$;

  public readonly folders$: Observable<FolderComponentObjects> = this._savedReportPageStore.folders$;
  public readonly reports$: Observable<SavedReportComponentObjects> = this._savedReportPageStore.reports$;
  public readonly breadcrumbs$: Observable<FolderComponentObjects> = this._savedReportPageStore.breadcrumbs$;
  public readonly currentFolder$: Observable<FolderComponentObject> = this._savedReportPageStore.currentFolder$;
  public readonly parentFolder$: Observable<FolderComponentObject> = this._savedReportPageStore.parentFolder$;

  public searchFilter: SavedReportComponentObject | FolderComponentObject;
  public disableDragDrop: boolean = true;

  constructor(
    private readonly router: Router,
    private readonly _savedReportPageStore: SavedReportPageStore
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  public openReportNav(report: SavedReportComponentObject): void {
    this.navReport = report;
    this.drawer.open();
  }

  public onOpenClicked(report: SavedReportComponentObject): void {
    this.router.navigate([report.url$.value]);
  }

  public onOpenInNewTab(report: SavedReportComponentObject): void {
    window.open(report.url$.value, '_blank');
  }


  public selectFolder(folder: FolderComponentObject): void {
    this.searchFilter = null;
    this._savedReportPageStore.selectFolder(folder);
  }

  public drop(event: CdkDragDrop<Array<SavedReportComponentObject>>, folder: FolderComponentObject) {
    const index: number = event.previousIndex;
    const report: SavedReportComponentObject = event.previousContainer.data[index];

    this._savedReportPageStore.modeReportToFolder({ report: report, folder: folder });
  }

  public moveReportToParentFolder(event: CdkDragDrop<Array<SavedReportComponentObject>>): void {
    const index: number = event.previousIndex;
    const report: SavedReportComponentObject = event.previousContainer.data[index];

    this._savedReportPageStore.moveReportToParentFolder(report);
  }

  public onFolderBack(): void {
    this._savedReportPageStore.folderBack();
  }

  public onSearchOpen(searchBarComponent: SearchBarComponent, item: FolderComponentObject | SavedReportComponentObject): void {
    if (item instanceof SavedReportComponentObject) {
      this.onOpenClicked(item);
    } else {
      this._savedReportPageStore.selectFolder(item);
    }

    searchBarComponent.clear();
  }

  public onSearchFilter(searchBarComponent: SearchBarComponent, item: FolderComponentObject | SavedReportComponentObject): void {
    this._savedReportPageStore.selectFolder(item.folder$.value);
    this.searchFilter = item;
    searchBarComponent.clear();
  }

}
